import React from 'react';
import axios from 'axios';
import dayjs from 'dayjs';

import {
  Box,
  Button,
  Card,
  TextField,
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  LinearProgress,
  MenuItem,
  Paper,
  Select,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';

import TypographyM from '@mui/material/Typography';
import IconButtonM from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import InsightsIcon from '@mui/icons-material/Insights';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import BasicTable2 from '../tools/BasicTable2';
import ImageEditor from '../tools/ImageEditor';
import LoadingDialog from '../tools/LoadingDialog.js';
import MessageDialog from '../tools/MessageDialog.js';
import VoucherStatistics from './VoucherStatistics.js';
import * as ETVConstants from '../ETVConstants';
import { Check, DisabledByDefault, SyncDisabledOutlined, ToggleOff, ToggleOn } from '@mui/icons-material';

/**
 * VoucherMgmt (polished UI)
 * - Matches the visual language of the new SurveyMgmt
 * - Container + Card layout, tidy spacing
 * - Nicer empty state, integrated progress
 * - Clear call-to-actions
 * - Structured dialogs (image editor + form sections)
 */
class VoucherMgmt extends React.Component {
  constructor(props) {
    super(props);
    this.receiveImage = this.receiveImage.bind(this);
  }

  setDefaultState() {
    this.setState({
      items: [],
      isLoaded: false,
      isLoading: false,
      window: undefined,
      info_type: 'info',
      info_message: '',
      info_title: '',
      spinning: false,
      qr_image: undefined,
      qr_image_title: undefined,
      new_title: '',
      new_desc: '',
      new_terms: 'Each coupon can be used only 1 time. There is only 1 coupon per device. Each coupon is valid for a limited time only and expires at the time specified. Coupons can not be replaced. Coupons may be discontinued at any time. No refund possible. Coupons may be invalidated for any kind of reason, and no claims can be made.',
      max_available_vouchers: 200,
      max_vouchers_per_day: -1,
      max_vouchers_per_user: 1,
      validity_date: dayjs().add(3, 'month'),
      validity_hours: 168,
      terminal_id: '',
      validating: false,
      location_id: 'web',
      voucher_img: undefined,
      content_ratio: 1,
      selected_voucher_def_id: undefined,
    });
  }

  state = {
    items: [],
    isLoaded: false,
    isLoading: false,
    window: undefined,
    info_type: 'info',
    info_message: '',
    info_title: '',
    spinning: false,
    qr_image: undefined,
    qr_image_title: undefined,
    new_title: '',
    new_desc: '',
    new_terms:'Each coupon can be used only 1 time. There is only 1 coupon per device. Each coupon is valid for a limited time only and expires at the time specified. Coupons can not be replaced. Coupons may be discontinued at any time. No refund possible. Coupons may be invalidated for any kind of reason, and no claims can be made.',
    max_available_vouchers: 200,
    max_vouchers_per_day: -1,
    max_vouchers_per_user: 1,
    validity_date: dayjs().add(3, 'month'),
    validity_hours: 168,
    terminal_id: '',
    validating: false,
    location_id: 'web',
    voucher_img: undefined,
    content_ratio: 1,
    selected_voucher_def_id: undefined,
  };

  componentDidUpdate() {
    if (!this.state.isLoaded && !this.state.isLoading) {
      this.loadItems();
    }
  }

  componentDidMount() {
    this.loadItems();
  }

  loadItems() {
    this.setState({ isLoading: true });
    const accessToken = localStorage.getItem('etv.access_token');
    const reqUserID = localStorage.getItem('etv.user_id');
    const url = `${ETVConstants.getServerBase()}/voucher_mgmt?action=get_voucher_def&user_id=${this.props.user_id}`;
    fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({ items: result.voucher_definitions, isLoaded: true, isLoading: false });
        },
        () => {
          this.setState({ items: [], isLoaded: true, isLoading: false });
        }
      );
  }

  showWindow(divID, show) {
    show ? this.setState({ window: divID }) : this.setState({ window: '' });
  }

  showInfoMessage(title, msg, isSpinning) {
    this.setState({ window: 'message_div', info_type: 'info', info_title: title, info_message: msg, spinning: !!isSpinning });
  }
  showSuccessMessage(title, msg) {
    this.setState({ window: 'message_div', info_type: 'success', info_title: title, info_message: msg, spinning: false });
  }
  showErrorMessage(title, msg) {
    this.setState({ window: 'message_div', info_type: 'error', info_title: title, info_message: msg, spinning: false });
  }
  closeInfoMessage() {
    this.setState({ window: '', info_type: '', info_title: '', info_message: undefined, spinning: false });
  }

  deleteVoucher(voucherDefID) {
    const url = `${ETVConstants.getServerBase()}/voucher_mgmt?action=delete_voucher_def&voucher_def_id=${voucherDefID}`;
    this.cmdSubmit(url, 'Coupon was deleted.', 'Failed to delete.');
  }

  enableVoucherDistribution(voucherDefID,enable) {
    const url = `${ETVConstants.getServerBase()}/voucher_mgmt?action=enable_active_distribution&enable=`+enable+`&voucher_def_id=${voucherDefID}`;
    if(enable) {
      this.cmdSubmit(url, 'Coupon distribution is actived', 'Failed to activate.');
    }else{
      this.cmdSubmit(url, 'Coupon distribution is inactive', 'Failed to deactivate.');
    }
  }

  cmdSubmit(url, successTxt, failText) {
    const accessToken = localStorage.getItem('etv.access_token');
    const reqUserID = localStorage.getItem('etv.user_id');
    fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.result) {
            this.showSuccessMessage(ETVConstants.trans('success'), successTxt);
            this.setState({ isLoaded: false });
          } else {
            this.showErrorMessage(ETVConstants.trans('error'), failText);
          }
        },
        (error) => {
          this.showErrorMessage(ETVConstants.trans('error'), error);
        }
      );
  }

  getItem(id) {
    for (let i = 0; i < this.state.items.length; i++) {
      if (this.state.items[i].id === id) return this.state.items[i];
    }
    return undefined;
  }

  analyzeVoucherStatistics(id) {
    this.setState({ window: 'analyze_voucher_div', selected_voucher_def_id: id });
  }

  base64ToFile(dataUrl, filename) {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], filename, { type: mime });
  }

  createNewVoucher() {
    const { voucher_img, content_ratio } = this.state;
    if (!voucher_img) {
      this.showErrorMessage('Missing Image', 'Please generate an image first.');
      return;
    }
    const today = new Date();
    const dateStr = today.toISOString().slice(0, 10);
    const imageFile = this.base64ToFile(voucher_img,`voucher_${dateStr}.png`);
    this.uploadFileToGCS(imageFile, content_ratio);
  }

  updateProgress(total, current) {
    let percentage = Math.floor((100 * current) / total);
    percentage = Math.min(100, percentage);
    this.showInfoMessage(ETVConstants.trans('upload'), '(' + percentage + '%)', true);
  }

  getMB(len) {
    const num = len / 1024 / 1024;
    const mb = Math.round(num * 100) / 100;
    return mb + 'MB';
  }

  uploadFileToGCS(file, contentRatio) {
    this.showInfoMessage(ETVConstants.trans('upload'), 'MB:(' + this.getMB(file.size) + ')', true);
    const accessToken = localStorage.getItem('etv.access_token');
    const reqUserID = localStorage.getItem('etv.user_id');
    const userID = this.props.user_id;
    const target_dir = '/' + userID + '/content_library';
    const myRand = Math.floor(Math.random() * 100000 + 1);
    const filename = myRand + '_' + file.name;
    const url = `${ETVConstants.getServerBase()}/content_library?action=request_upload&user_id=${userID}&target_dir=${target_dir}&filename=${encodeURIComponent(
      filename
    )}`;

    fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } })
      .then((res) => res.json())
      .then(
        (result) => {
          const formData = new FormData();
          Object.entries(result.fields).forEach(([key, value]) => formData.append(key, value));
          formData.append('file', file);
          const config = {
            headers: { 'content-type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) =>
              this.showInfoMessage(
                ETVConstants.trans('upload'),
                '(' + this.showPercentage(progressEvent.loaded, file.size) + ')',
                true
              ),
          };
          this.showInfoMessage(ETVConstants.trans('upload'), '(' + this.getMB(file.size) + ')', true);
          axios
            .post(result.url, formData, config)
            .then(() => {
              this.showInfoMessage(ETVConstants.trans('upload'), ETVConstants.trans('register'), true);
              this.registerNewVoucher(filename, target_dir, contentRatio, file.size);
            })
            .catch((error) => {
              this.showErrorMessage('', 'error: ' + error);
            });
        },
        (error) => {
          this.showErrorMessage('', 'error: ' + error);
        }
      );
  }

  showPercentage(loaded, total) {
    if (total === 0) return '0%';
    const percent = Math.min(100, (loaded / total) * 100);
    return `${percent.toFixed(0)}%`;
  }

  showNewCouponDiv() {
    this.showWindow('create_new_voucher_div', true);
  }

  validateInputs() {
    if (!this.state.voucher_img) return false;
    if (!this.state.new_title || this.state.new_title.length === 0) return false;
    if (!this.state.terminal_id || this.state.terminal_id.length === 0) return false;
    if (!this.state.validity_date) return false;
    return true;
  }

  registerNewVoucher(filename, targetDir, contentRatio, fileSize) {
    this.showInfoMessage(ETVConstants.trans('upload'), ETVConstants.trans('register_coupons'), true);
    const accessToken = localStorage.getItem('etv.access_token');
    const reqUserID = localStorage.getItem('etv.user_id');
    const virtualDir = '/';

    let url = `${ETVConstants.getServerBase()}/voucher_mgmt?action=add_new_voucher`;
    url += `&title=${encodeURIComponent(this.state.new_title)}`;
    url += `&desc=${encodeURIComponent(this.state.new_desc)}`;
    url += `&terms=${encodeURIComponent(this.state.new_terms)}`;
    url += `&user_id=${this.props.user_id}`; // keep original behavior
    url += `&nof_vouchers=${this.state.max_available_vouchers}`;
    url += `&max_per_user=${this.state.max_vouchers_per_user}`;
    url += `&max_per_day=${this.state.max_vouchers_per_day}`;
    url += `&validity_date=${ETVConstants.formatDate(this.state.validity_date)}`;
    url += `&validity_hours=${this.state.validity_hours}`;
    url += `&terminal_id=${encodeURIComponent(this.state.terminal_id)}`;
    url += `&user_id=${reqUserID}`; // existing API expects this as well
    url += `&target_dir=${targetDir}`;
    url += `&virtual_dir=${encodeURIComponent(virtualDir)}`;
    url += `&content_ratio=${contentRatio}`;
    url += `&file_size=${fileSize}`;
    url += `&filename=${encodeURIComponent(filename)}`;

    fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result['result']) {
            this.showSuccessMessage(ETVConstants.trans('coupon'), ETVConstants.trans('coupon_registered'));
            this.setState({ isLoaded: false });
          } else {
            this.showErrorMessage(ETVConstants.trans('coupon'), result.reason);
          }
        },
        (error) => {
          this.showInfoMessage(ETVConstants.trans('error'), error);
        }
      );
  }

  printPercentage(a, b) {
    if (!b || b === 0) return '0%';
    const num = (a / b) * 100;
    return num.toFixed(0) + '%';
  }

  printQRCoupon(voucherDefID, title) {
    const reDirectURL = 'https://c.e1e.tv/iv/' + voucherDefID; // locationID added by suffix
    const qrCode = 'https://e1e.tv/q?c=' + encodeURIComponent(reDirectURL);
    this.setState({ qr_image: qrCode, qr_image_title: title });
    this.setState({ window: 'qr_preview_div' });
  }

  setValidityDate = (date) => {
    this.setState({ validity_date: date });
  };

  printValidityHours(hours) {
    if (hours < 0) return ETVConstants.trans('no_expiry_date');
    if (hours === 1) return ETVConstants.trans('1h');
    if (hours === 2) return ETVConstants.trans('2h');
    if (hours === 4) return ETVConstants.trans('4h');
    if (hours === 8) return ETVConstants.trans('8h');
    if (hours < 24) return hours + ' hours';
    if (hours === 24) return ETVConstants.trans('1_day');
    if (hours === 48) return ETVConstants.trans('2_days');
    if (hours < 168) return hours / 24 + ' days';
    if (hours === 168) return ETVConstants.trans('1_week');
    if (hours === 336) return ETVConstants.trans('2_weeks');
    if (hours === 672) return ETVConstants.trans('4_weeks');
    return hours / 168 + ' weeks';
  }

  printMaxPerDay(nof) {
    if (nof < 0) return ETVConstants.trans('no_limit');
    return nof;
  }

  inputOK(field) {
    if (!field) return false;
    return field.length > 0;
  }

  receiveImage(imgDataUrl, contentRatio) {
    this.setState({ voucher_img: imgDataUrl, content_ratio: contentRatio });
  }

  // ---------- UI helpers ----------
  distributedCell(row) {
    const pct = row.max_vouchers ? Math.min(100, Math.round((row.distributed_vouchers / row.max_vouchers) * 100)) : 0;
    return (
      <Stack spacing={0.5} sx={{ minWidth: 120 }}>
        <Typography variant="caption">{pct}% ({row.distributed_vouchers})</Typography>
        <LinearProgress variant="determinate" value={pct} />
      </Stack>
    );
  }

  render() {
    const columnsData = [
      {
        title: ETVConstants.trans('title'),
        field: 'title',
        render: (rowData) => (
          <Box sx={{ minWidth: 180 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {rowData.title}
            </Typography>
          </Box>
        ),
      },
      {
        title: ETVConstants.trans('view_qr'),
        field: 'desc',
        render: (rowData) => (
          <Button variant="contained" size="small" startIcon={<QrCode2Icon />} onClick={() => this.printQRCoupon(rowData.voucher_def_id, rowData.title)}>
            QR
          </Button>
        ),
      },
      { title: ETVConstants.trans('terminal_id'), field: 'terminalID' },
      {
        title: ETVConstants.trans('validity_after_distribution'),
        field: 'validity_hours',
        render: (rowData) => <span>{this.printValidityHours(rowData.validity_hours)}</span>,
      },
      { title: ETVConstants.trans('expiry_date'), field: 'validity_date' },
      {
        title: ETVConstants.trans('max_per_user'),
        field: 'max_per_user',
        render: (rowData) => <span>{rowData.max_per_user > 0 ? rowData.max_per_user : ETVConstants.trans('no_limit')}</span>,
      },
      {
        title: ETVConstants.trans('max_per_day'),
        field: 'max_per_day',
        render: (rowData) => <span>{this.printMaxPerDay(rowData.max_per_day)}</span>,
      },
      { title: ETVConstants.trans('total_available'), field: 'max_vouchers' },
      {
        title: ETVConstants.trans('distributed'),
        field: 'distributed_vouchers',
        render: (rowData) => this.distributedCell(rowData),
      },
      { title: ETVConstants.trans('used'), field: 'used_vouchers' },
      {
        title: ETVConstants.trans('analyze'),
        field: '',
        render: (rowData) => (
          <Button variant="contained" size="small" startIcon={<InsightsIcon />} onClick={() => this.analyzeVoucherStatistics(rowData.voucher_def_id)}>
            {ETVConstants.trans('analyze')}
          </Button>
        ),
      },
      {
        title: ETVConstants.trans('active'),
        field: '',
        render: (rowData) => (
          <Tooltip title={ETVConstants.trans('active')}>
            <IconButton size="large" color={rowData.active_distribution?"success":"error"} onClick={() => this.enableVoucherDistribution(rowData.voucher_def_id, !rowData.active_distribution)}>
              {rowData.active_distribution?<ToggleOn fontSize='large'/>:<ToggleOff fontSize='large'/>}
            </IconButton>
          </Tooltip>
        ),
      },
      {
        title: ETVConstants.trans('delete'),
        field: '',
        render: (rowData) => (
          <Tooltip title={ETVConstants.trans('delete')}>
            <IconButton size="small" color="error" onClick={() => this.deleteVoucher(rowData.voucher_def_id)}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ),
      },
    ];

    return (
      <Container maxWidth={false} sx={{ py: 3, px: { xs: 2, sm: 3 } }}>
        {/* Header */}
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <CardGiftcardIcon />
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              {ETVConstants.trans('coupon_management') || 'Coupon Management'}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Button variant="contained" startIcon={<CardGiftcardIcon />} onClick={() => this.showNewCouponDiv()}>
              {ETVConstants.trans('create_new_coupon')}
            </Button>
          </Stack>
        </Stack>

        {/* Table Card */}
        <Card sx={{ borderRadius: 3 }}>
          <CardHeader title={ETVConstants.trans('coupons_list') || 'Coupons'} subheader={ETVConstants.trans('latest_results') || 'latest results'} />
          {this.state.isLoading && <LinearProgress />}
          <Divider />
          <CardContent sx={{ px: 0 }}>
            {this.state.items && this.state.items.length > 0 ? (
              <Box sx={{ width: '100%', px: 2 }}>
<BasicTable2 data={this.state.items} columns={columnsData} title="" pageSize={10} allow_search={true} />
</Box>
            ) : (
              <Stack alignItems="center" spacing={1} sx={{ py: 6, color: 'text.secondary' }}>
                <InfoOutlinedIcon />
                <Typography variant="body2">{ETVConstants.trans('no_coupons_yet') || 'no coupons yet'}</Typography>
              </Stack>
            )}
          </CardContent>
        </Card>

        {/* Message dialog */}
        <MessageDialog
          spinning={this.state.spinning}
          type={this.state.info_type}
          open={this.state.window === 'message_div'}
          onClose={() => {
            this.closeInfoMessage();
          }}
          title={this.state.info_title}
          message={this.state.info_message}
        />

        {/* QR preview */}
        <Dialog open={this.state.window === 'qr_preview_div'} maxWidth="xs" fullWidth onClose={() => {}}>
          <DialogTitle>{this.state.qr_image_title}</DialogTitle>
          <DialogContent dividers>
            <Stack spacing={2}>
              <TextField
                variant="outlined"
                label={ETVConstants.trans('location_reference')}
                helperText={ETVConstants.trans('optional_location_reference_for_future_tracking')}
                inputProps={{ maxLength: 15 }}
                fullWidth
                value={this.state.location_id}
                onChange={(event) => this.setState({ location_id: event.target.value })}
              />
              {this.state.qr_image && (
                <Paper variant="outlined" sx={{ p: 2, bgcolor: 'background.default' }}>
                  <Box display="flex" justifyContent="center">
                    <Box
                      component="img"
                      src={`${this.state.qr_image}/${this.state.location_id.length > 0 ? this.state.location_id : 'web'}`}
                      alt="QR Code"
                      sx={{ width: '100%', maxWidth: 320, height: 'auto' }}
                    />
                  </Box>
                </Paper>
              )}
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.closeInfoMessage()} variant="contained">
              {ETVConstants.trans('close')}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Create New Voucher */}
        <Dialog open={this.state.window === 'create_new_voucher_div'} maxWidth="lg" fullWidth onClose={() => {}}>
          <DialogTitle>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              {ETVConstants.trans('create_new_coupon')}
            </Typography>
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={4}>
              {/* Left: Image Editor */}
              <Grid item xs={12} md={8}>
                <ImageEditor onChange={this.receiveImage} contentRatio={this.state.content_ratio} />
              </Grid>

              {/* Right: Form */}
              <Grid item xs={12} md={4}>
                <Stack spacing={2}>
                  <TextField
                    variant="outlined"
                    placeholder={"e.g. 50% off"}
                    label={ETVConstants.trans('title')}
                    fullWidth
                    value={this.state.new_title}
                    onChange={(e) => this.setState({ new_title: e.target.value })}
                  />
                  <TextField
                    variant="outlined"
                    label={ETVConstants.trans('description')}
                    placeholder={"e.g. get 50% off for the second item"}
                    fullWidth
                    value={this.state.new_desc}
                    onChange={(e) => this.setState({ new_desc: e.target.value })}
                  />

                  <Divider textAlign="left">
                    <Chip label={ETVConstants.trans('terms_conditions')} size="small" />
                  </Divider>
                  <TextField
                    multiline
                    minRows={4}
                    variant="outlined"
                    fullWidth
                    value={this.state.new_terms}
                    onChange={(e) => this.setState({ new_terms: e.target.value })}
                  />

                  <Divider textAlign="left">
                    <Chip label={ETVConstants.trans('limits') || 'limits'} size="small" />
                  </Divider>
                  <FormControl fullWidth>
                    <InputLabel>{ETVConstants.trans('total_number_coupons')}</InputLabel>
                    <Select
                      label={ETVConstants.trans('total_number_coupons')}
                      value={this.state.max_available_vouchers}
                      onChange={(e) => this.setState({ max_available_vouchers: e.target.value })}
                    >
                      {[20, 50, 100, 200, 500, 1000, 5000].map((val) => (
                        <MenuItem key={val} value={val}>
                          {val}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth>
                    <InputLabel>{ETVConstants.trans('max_coupons_per_day')}</InputLabel>
                    <Select
                      label={ETVConstants.trans('max_coupons_per_day')}
                      value={this.state.max_vouchers_per_day}
                      onChange={(e) => this.setState({ max_vouchers_per_day: e.target.value })}
                    >
                      {[10, 20, 50, 100, 250, 500, 1000, 5000].map((val) => (
                        <MenuItem key={val} value={val}>
                          {val}
                        </MenuItem>
                      ))}
                      <MenuItem value={-1}>unlimited</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl fullWidth>
                    <InputLabel>{ETVConstants.trans('max_coupons_per_user')}</InputLabel>
                    <Select
                      label={ETVConstants.trans('max_coupons_per_user')}
                      value={this.state.max_vouchers_per_user}
                      onChange={(e) => this.setState({ max_vouchers_per_user: e.target.value })}
                    >
                      {[1, 2, 3, 5, 10].map((val) => (
                        <MenuItem key={val} value={val}>
                          {val}
                        </MenuItem>
                      ))}
                      <MenuItem value={-1}>{ETVConstants.trans('no_limit')}</MenuItem>
                    </Select>
                  </FormControl>

                  <Divider textAlign="left">
                    <Chip label={ETVConstants.trans('validity') || 'validity'} size="small" />
                  </Divider>
                  <FormControl fullWidth>
                    <InputLabel>{ETVConstants.trans('coupon_expiry_after_distribution')}</InputLabel>
                    <Select
                      label={ETVConstants.trans('coupon_expiry_after_distribution')}
                      value={this.state.validity_hours}
                      onChange={(e) => this.setState({ validity_hours: e.target.value })}
                    >
                      {[1, 2, 4, 8, 24, 48, 168, 672].map((val) => (
                        <MenuItem key={val} value={val}>
                          {this.printValidityHours(val)}
                        </MenuItem>
                      ))}
                      <MenuItem value={-1}>{ETVConstants.trans('no_expiry_date')}</MenuItem>
                    </Select>
                  </FormControl>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label={ETVConstants.trans('validity_date')}
                      format="YYYY-MM-DD"
                      value={this.state.validity_date ? this.state.validity_date : null}
                      onChange={this.setValidityDate}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          required: true,
                          error: this.state.validating && !this.state.validity_date,
                          helperText:
                            this.state.validating && !this.state.validity_date ? ETVConstants.trans('required_field') : '',
                        },
                      }}
                    />
                  </LocalizationProvider>

                  <Divider textAlign="left">
                    <Chip label={ETVConstants.trans('validation') || 'validation'} size="small" />
                  </Divider>
                  <Typography variant="body2" color="text.secondary">
                    {ETVConstants.trans('expl_terminal_validation_code')}
                  </Typography>
                  <TextField
                    error={this.state.validating && !this.inputOK(this.state.terminal_id)}
                    helperText={
                      !this.state.validating || this.inputOK(this.state.terminal_id)
                        ? ''
                        : ETVConstants.trans('required_field')
                    }
                    required
                    label={ETVConstants.trans('coupon_validation_terminal_code')}
                    fullWidth
                    value={this.state.terminal_id}
                    onChange={(e) => this.setState({ terminal_id: e.target.value })}
                  />
                </Stack>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.showWindow('create_new_voucher_div', false)}>{ETVConstants.trans('close')}</Button>
            <Button
              variant="contained"
              startIcon={<CardGiftcardIcon />}
              disabled={!this.validateInputs()}
              onClick={() => this.createNewVoucher()}
            >
              {ETVConstants.trans('create_new_coupon')}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Analyze */}
        <Dialog open={this.state.window === 'analyze_voucher_div'} maxWidth="xl" fullWidth onClose={() => {}}>
          <DialogTitle>{ETVConstants.trans('analyze_coupon')}</DialogTitle>
          <DialogContent dividers>
            {this.state.selected_voucher_def_id ? (
              <VoucherStatistics voucher_def_id={this.state.selected_voucher_def_id} />
            ) : (
              <span />
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.showWindow('analyze_voucher_div', false)}>{ETVConstants.trans('close')}</Button>
          </DialogActions>
        </Dialog>

        <LoadingDialog open={this.state.window === 'progress_dialog'} message={this.state.progress_message || 'loading...'} />
      </Container>
    );
  }
}

export default VoucherMgmt;
